export default function About() {
    return (
        <div>
            <h1 className="text-5xl mb-4">Random User Generator</h1>
            <p className="mb-4">Random User Generator - Simple example how to use our API.</p>
            <p className="text-lg text-gray-400">Version: <span className="text-white">1.0</span></p>
        </div>
    )
}
